export class LanguageData{
LANGCODE:string;
LANGUAGE:string;
SHORTNAME:string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/MedicalRequest/LanguageData.ts